"use client"

import { useEffect } from "react"
import Link from "next/link"
import { Server } from "lucide-react"
import { Button } from "@/components/ui/button"

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="flex min-h-screen flex-col bg-[#1a1c1e] text-white">
      <header className="w-full border-b border-[#2c2e30] bg-[#1a1c1e]/95 backdrop-blur supports-[backdrop-filter]:bg-[#1a1c1e]/60">
        <div className="container flex h-16 items-center space-x-4 sm:justify-between sm:space-x-0">
          <div className="flex gap-6 md:gap-10">
            <Link href="/" className="flex items-center space-x-2">
              <Server className="h-6 w-6 text-[#e57312]" />
              <span className="inline-block font-bold text-[#e57312]">HSVE</span>
            </Link>
            <nav className="hidden gap-6 md:flex">
              <Link
                href="/"
                className="flex items-center text-sm font-medium text-gray-300 transition-colors hover:text-white"
              >
                Home
              </Link>
              <Link
                href="/about"
                className="flex items-center text-sm font-medium text-gray-300 transition-colors hover:text-white"
              >
                About
              </Link>
              <div className="relative group">
                <button className="flex items-center text-sm font-medium text-gray-300 transition-colors hover:text-white">
                  Services
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="ml-1 h-3 w-3"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>
                <div className="absolute left-0 top-full z-50 mt-2 hidden w-48 rounded-md bg-[#252729] p-2 shadow-lg group-hover:block group-focus-within:block">
                  <Link
                    href="/templates"
                    className="block rounded-md px-3 py-2 text-sm text-gray-300 hover:bg-[#1a1c1e] hover:text-white"
                  >
                    Proxmox Templates Script
                  </Link>
                </div>
              </div>
              <Link
                href="/contact"
                className="flex items-center text-sm font-medium text-gray-300 transition-colors hover:text-white"
              >
                Contact
              </Link>
            </nav>
          </div>
          <div className="flex flex-1 items-center justify-end space-x-4">
            <Button
              variant="outline"
              size="sm"
              className="hidden sm:flex border-[#e57312] text-[#e57312] hover:bg-[#e57312]/10"
            >
              Log in
            </Button>
          </div>
        </div>
      </header>

      <main className="flex min-h-screen flex-col items-center justify-center text-center">
        <div className="space-y-4">
          <h1 className="text-4xl font-bold">404</h1>
          <h2 className="text-2xl font-semibold">Page Not Found</h2>
          <p className="text-muted-foreground">The page you are looking for doesn't exist or has been moved.</p>
          <Button asChild>
            <Link href="/">Return Home</Link>
          </Button>
        </div>
      </main>

      <footer className="w-full border-t border-[#2c2e30] bg-[#1a1c1e] py-6">
        <div className="container text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Harvey's Virtual Environment. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}
